module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4%",
      "float": "right"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })])]), _vm._v(" "), _c('div', [_c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive-demo",
    attrs: {
      "value": _vm.balanceCarryOverLists,
      "paginator": true,
      "rows": 10,
      "filters": _vm.filters
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(slotProps.index + 1) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Group",
      "field": "accountHeadName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountHeadName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountHeadName', $$v)
            },
            expression: "filters['accountHeadName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Sub Group",
      "field": "accountSubHeadName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountSubHeadName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountSubHeadName', $$v)
            },
            expression: "filters['accountSubHeadName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Name",
      "field": "name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'name', $$v)
            },
            expression: "filters['name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Balance",
      "field": "closingBalance",
      "filterMatchMode": "contains",
      "bodyStyle": "text-align: right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n          " + _vm._s(slotProps.data.openingBalance < 0 ? slotProps.data.openingBalance * (-1) : slotProps.data.openingBalance) + "\n        ")]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['openingBalance']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'openingBalance', $$v)
            },
            expression: "filters['openingBalance']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Dr-Cr",
      "field": "openingDrCr",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['openingDrCr']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'openingDrCr', $$v)
            },
            expression: "filters['openingDrCr']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2dd7f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/closingFinalYear/balanceCarryOverReport.vue
// module id = 2112
// module chunks = 0